// Judge.me Test and Debug Script
// This script exposes Judge.me testing functions to the global scope for debugging

window.JudgeMeTest = {
  
  // Test function to check Judge.me availability
  checkJudgeMeStatus() {
    console.log('=== Judge.me Status Check ===');
    console.log('window.jdgm available:', !!window.jdgm);
    console.log('window.JudgeMe available:', !!window.JudgeMe);
    
    if (window.jdgm) {
      console.log('window.jdgm methods available:');
      console.log('- loadBadges:', typeof window.jdgm.loadBadges);
      console.log('- customizeBadges:', typeof window.jdgm.customizeBadges);
      console.log('- autoInstallWidgets:', typeof window.jdgm.autoInstallWidgets);
      console.log('- scanForWidgets:', typeof window.jdgm.scanForWidgets);
      console.log('- processWidget:', typeof window.jdgm.processWidget);
      
      // Check for Judge.me script source
      const judgeMeScript = document.querySelector('script[src*="judge.me"]');
      if (judgeMeScript) {
        console.log('Judge.me script source:', judgeMeScript.src);
        const shopMatch = judgeMeScript.src.match(/shop=([^&]+)/);
        if (shopMatch) {
          console.log('Shop domain:', shopMatch[1]);
        }
      }
    }
    
    // Check existing widgets
    const existingWidgets = document.querySelectorAll('.jdgm-widget');
    const dynamicWidgets = document.querySelectorAll('.dynamic-product .jdgm-widget');
    console.log('Existing Judge.me widgets found:', existingWidgets.length);
    console.log('Dynamic product widgets found:', dynamicWidgets.length);
    
    return {
      jdgmAvailable: !!window.jdgm,
      judgeMeAvailable: !!window.JudgeMe,
      existingWidgets: existingWidgets.length,
      dynamicWidgets: dynamicWidgets.length
    };
  },
  
  // Create test Judge.me widgets
  createTestWidget(productId = '4450706849838') {
    console.log(`=== Creating Test Widget for Product ${productId} ===`);
    
    const testContainer = document.getElementById('judgeme-test-container') || this.createTestContainer();
    
    const widget = document.createElement('div');
    widget.className = 'jdgm-widget jdgm-preview-badge dynamic-test-widget';
    widget.setAttribute('data-jdgm-product-id', productId);
    widget.setAttribute('data-id', productId);
    widget.setAttribute('data-auto-install', 'false');
    widget.setAttribute('data-jdgm-processed', 'false');
    widget.innerHTML = '<span>Loading Judge.me review...</span>';
    
    testContainer.appendChild(widget);
    console.log('Test widget created:', widget);
    
    return widget;
  },
  
  // Create test container
  createTestContainer() {
    const container = document.createElement('div');
    container.id = 'judgeme-test-container';
    container.style.cssText = `
      position: fixed;
      top: 10px;
      right: 10px;
      background: white;
      border: 2px solid #ccc;
      padding: 15px;
      z-index: 9999;
      max-width: 300px;
      border-radius: 5px;
      box-shadow: 0 4px 8px rgba(0,0,0,0.1);
    `;
    container.innerHTML = '<h3>Judge.me Test Area</h3>';
    document.body.appendChild(container);
    return container;
  },
  
  // Test Judge.me initialization methods
  testJudgeMeInit(productId = '4450706849838') {
    console.log(`=== Testing Judge.me Initialization for Product ${productId} ===`);
    
    const widget = this.createTestWidget(productId);
    const results = {
      widget: widget,
      methods: []
    };
    
    // Test Method 1: loadBadges
    if (window.jdgm && window.jdgm.loadBadges) {
      try {
        console.log('Testing jdgm.loadBadges...');
        window.jdgm.loadBadges([widget]);
        results.methods.push('loadBadges: success');
      } catch (error) {
        console.error('jdgm.loadBadges error:', error);
        results.methods.push('loadBadges: error - ' + error.message);
      }
    } else {
      results.methods.push('loadBadges: not available');
    }
    
    // Test Method 2: customizeBadges
    if (window.jdgm && window.jdgm.customizeBadges) {
      try {
        console.log('Testing jdgm.customizeBadges...');
        window.jdgm.customizeBadges();
        results.methods.push('customizeBadges: success');
      } catch (error) {
        console.error('jdgm.customizeBadges error:', error);
        results.methods.push('customizeBadges: error - ' + error.message);
      }
    } else {
      results.methods.push('customizeBadges: not available');
    }
    
    // Test Method 3: autoInstallWidgets
    if (window.jdgm && window.jdgm.autoInstallWidgets) {
      try {
        console.log('Testing jdgm.autoInstallWidgets...');
        window.jdgm.autoInstallWidgets();
        results.methods.push('autoInstallWidgets: success');
      } catch (error) {
        console.error('jdgm.autoInstallWidgets error:', error);
        results.methods.push('autoInstallWidgets: error - ' + error.message);
      }
    } else {
      results.methods.push('autoInstallWidgets: not available');
    }
    
    // Test Method 4: scanForWidgets
    if (window.jdgm && window.jdgm.scanForWidgets) {
      try {
        console.log('Testing jdgm.scanForWidgets...');
        window.jdgm.scanForWidgets();
        results.methods.push('scanForWidgets: success');
      } catch (error) {
        console.error('jdgm.scanForWidgets error:', error);
        results.methods.push('scanForWidgets: error - ' + error.message);
      }
    } else {
      results.methods.push('scanForWidgets: not available');
    }
    
    // Test Method 5: processWidget
    if (window.jdgm && window.jdgm.processWidget) {
      try {
        console.log('Testing jdgm.processWidget...');
        window.jdgm.processWidget(widget);
        results.methods.push('processWidget: success');
      } catch (error) {
        console.error('jdgm.processWidget error:', error);
        results.methods.push('processWidget: error - ' + error.message);
      }
    } else {
      results.methods.push('processWidget: not available');
    }
    
    // Check widget after 2 seconds
    setTimeout(() => {
      console.log('=== Widget Status After 2 Seconds ===');
      console.log('Widget innerHTML:', widget.innerHTML);
      console.log('Widget classes:', widget.className);
      console.log('Widget attributes:', Array.from(widget.attributes).map(attr => `${attr.name}="${attr.value}"`));
      
      if (widget.innerHTML.trim() !== '<span>Loading Judge.me review...</span>') {
        console.log('✅ Widget content changed - Judge.me may be working!');
      } else {
        console.log('❌ Widget content unchanged - Judge.me not initializing');
      }
    }, 2000);
    
    return results;
  },
  
  // Test with multiple product IDs
  testMultipleProducts() {
    const productIds = ['4450706849838', '6704246390830', '4450098642990', '4632847351854'];
    console.log('=== Testing Multiple Products ===');
    
    productIds.forEach((productId, index) => {
      setTimeout(() => {
        console.log(`Testing product ${index + 1}/${productIds.length}: ${productId}`);
        this.testJudgeMeInit(productId);
      }, index * 1000); // Stagger tests by 1 second
    });
  },
  
  // Clean up test widgets
  cleanup() {
    const testContainer = document.getElementById('judgeme-test-container');
    if (testContainer) {
      testContainer.remove();
      console.log('Test container removed');
    }
    
    const testWidgets = document.querySelectorAll('.dynamic-test-widget');
    testWidgets.forEach(widget => widget.remove());
    console.log(`Removed ${testWidgets.length} test widgets`);
  },
  
  // Run full test suite
  runFullTest() {
    console.log('🧪 Running Full Judge.me Test Suite...');
    
    // Step 1: Check status
    const status = this.checkJudgeMeStatus();
    
    // Step 2: Test single product
    if (status.jdgmAvailable) {
      setTimeout(() => {
        console.log('\n📝 Testing single product initialization...');
        this.testJudgeMeInit();
      }, 1000);
      
      // Step 3: Test multiple products
      setTimeout(() => {
        console.log('\n📝 Testing multiple products...');
        this.testMultipleProducts();
      }, 3000);
    } else {
      console.log('❌ Judge.me not available - test stopped');
    }
    
    // Auto cleanup after 30 seconds
    setTimeout(() => {
      console.log('\n🧹 Auto-cleanup...');
      this.cleanup();
    }, 30000);
  }
};

// Quick access functions
window.testJudgeMe = () => window.JudgeMeTest.runFullTest();
window.checkJudgeMe = () => window.JudgeMeTest.checkJudgeMeStatus();
window.cleanupJudgeMe = () => window.JudgeMeTest.cleanup();

console.log('🧪 Judge.me Test Script Loaded!');
console.log('Available functions:');
console.log('- testJudgeMe() - Run full test suite');
console.log('- checkJudgeMe() - Check Judge.me status');
console.log('- cleanupJudgeMe() - Clean up test widgets');
console.log('- window.JudgeMeTest - Full test object with all methods'); 